module.exports = __webpack_public_path__ + "media/img/scholarships/English Year 13-3d4b133f9dc2c0f655c3d9f32193abca.svg";